import React from 'react'
import classNames from 'classnames'
import { FlexColumn, FlexRow } from '@/atoms/FlexContainers'
import { CircleInfoIcon } from '@/atoms/Icons/CircleInfoIcon'
import { TicketIcon } from '@/atoms/Icons/TicketIcon'
import { CaptionLG, CaptionMD, TitleMD } from '@/atoms/Text'
import { useTranslate } from '@/utils/translate/translate-client'

interface GiveawayRefundCardProps {
  className?: string
  title: string
  description: string
  onInfoClick?: () => void
}

export const GiveawayRefundCard: React.FC<GiveawayRefundCardProps> = ({
  className,
  title,
  description,
  onInfoClick,
}) => {
  const { t } = useTranslate('tickets')

  return (
    <FlexColumn
      className={classNames('gap-1 mx-auto w-full border-2 border-cool-03 bg-info-100 p-4 rounded-3xl', className)}
    >
      <FlexRow className="gap-1">
        <TicketIcon size={20} color="cool-03" />
        <TitleMD weight="semibold" color="black">
          {title}
        </TitleMD>
      </FlexRow>
      <CaptionLG color="core-gray-700">{description}</CaptionLG>

      <button onClick={onInfoClick} className="ml-auto flex items-center gap-1">
        <CircleInfoIcon size={16} color="core-gray-700" />
        <CaptionMD weight="normal" color="core-gray-700" className="underline">
          {t('morePreSaleInfo', 'more info')}
        </CaptionMD>
      </button>
    </FlexColumn>
  )
}
